import React, { Component } from 'react'
import JewelryPanel from '../../jewelry-panel'
import Spacer from '../../../../components/spacer'
import SelectItem from '../../../../components/select-item'
import Slider from '../../../slider'
import {
  hideMultiStoneHaloMilgrain,
  showMultiStoneHaloPanel
} from '../../../../utils/jewelry-validation'

class MultiStoneHaloPanel extends Component {
  render () {
    const props = this.props

    const getSideStoneHaloWidthOptions = () => {
      return [...props.defaultHaloWidthOptions, {value: 'custom', label: 'Custom'}]
    }

    return (
      <JewelryPanel
        id='sideStoneHaloPanel'
        show={showMultiStoneHaloPanel(props)}
        isResetting={props.isResetting}>

        <Spacer xxs />

        <SelectItem
          label='Multi-Stone Halo'
          labelId='multistonehalo'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.has_side_stone_halo}
          onChange={props.onChangeVal.bind(this, 'has_side_stone_halo')}
          initVal={null}
        />

        <JewelryPanel
          id='sideStoneHaloContentPanel'
          show={props.has_side_stone_halo}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            id='side_stone_halo_style'
            label='Multi-Stone Halo Type'
            labelId='side_stone_halo_style'
            options={[
              {value: 'single', label: 'Single'},
              {value: 'double', label: 'Double'}
            ]}
            value={props.side_stone_halo_style}
            onChange={props.onChangeVal.bind(this, 'side_stone_halo_style')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='side_stone_overlapping_setting'
            label='Overlapping Halos?'
            labelId='side_stone_overlapping_setting'
            options={[
              {value: 'not_overlap', label: 'No'},
              {value: 'overlap', label: 'Overlap'},
              {value: 'outline', label: 'Outline'}
            ]}
            value={props.side_stone_overlapping_setting}
            onChange={props.onChangeVal.bind(this, 'side_stone_overlapping_setting')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='side_stone_halo_width'
            label='Multi-Stone Halo Width (Per Row)'
            labelId='sideStoneHaloWidth'
            options={getSideStoneHaloWidthOptions()}
            value={props.side_stone_halo_width}
            onChange={props.onChangeVal.bind(this, 'side_stone_halo_width')}
            initVal={null}
          />

          <JewelryPanel
            id='sideStoenHaloCustomWidthPanel'
            show={props.side_stone_halo_width === 'custom'}
            isResetting={props.isResetting}>

            <Spacer xxs />

            <h4>Multi-Stone Halo Custom Width</h4>
            <Slider
              id='side_stone_halo_custom_width'
              sliderId='side_stone_halo_custom_width'
              labelRight='mm'
              single
              input
              min={1.0}
              max={5.0}
              step={0.1}
              value={props.side_stone_halo_custom_width}
              onChange={props.onChangeVal.bind(this, 'side_stone_halo_custom_width')}
              initVal={1}
            />
          </JewelryPanel>

          <Spacer xxs />

          <SelectItem
            label='Quality of Diamonds in Multi-Stone Halo'
            id='multiStoneHaloQuality'
            labelId='side_stone_halo_quality'
            options={[
              {value: 'standard', label: 'Standard'},
              {value: 'plus', label: 'Plus'},
              {value: 'lab_grown', label: 'Lab Grown'},
            ]}
            value={props.side_stone_halo_quality}
            onChange={props.onChangeVal.bind(this, 'side_stone_halo_quality')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='side_stone_halo_setting_style'
            labelId='side_stone_halo_setting_style'
            label='Multi-Stone Halo Setting Style'
            options={[
              {value: 'pave', label: 'Pavé'},
              {value: 'pave_border', label: 'Pavé w/ Border'},
              {value: 'channel_set', label: 'Channel Set'},
              {value: 'bezel_set', label: 'Bezel Set'},
              {value: 'shared_claw_set', label: 'Shared Claw'}
            ]}
            value={props.side_stone_halo_setting_style}
            onChange={props.onChangeVal.bind(this, 'side_stone_halo_setting_style')}
            initVal={null}
          />

          <Spacer xxs hide={hideMultiStoneHaloMilgrain(props)} />

          <SelectItem
            label='Multi-Stone Halo Milgrain'
            id='multiStoneHaloMilgrain'
            labelId='side_stone_halo_milgrain'
            options={[
              {value: 'no', label: 'No'},
              {value: 'yes', label: 'Yes'}
            ]}
            value={props.side_stone_halo_milgrain}
            onChange={props.onChangeVal.bind(this, 'side_stone_halo_milgrain')}
            hide={hideMultiStoneHaloMilgrain(props)}
            initVal={null}
          />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default MultiStoneHaloPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/multi-stone-panel/multi-stone-halo-panel/index.js